import { type DailySummaryRecipientResponse } from "../api";
import { Utility } from "./utility";

export interface DailySummaryRecipient extends DailySummaryRecipientResponse {}

export class DailySummaryRecipient extends Utility<DailySummaryRecipient> {
  constructor(init?: Partial<DailySummaryRecipient>) {
    super();
    Object.assign(this, init);
  }
}
